
import React from 'react';
import './App.css';
import NavRouter from './router/NavRouter';
import SEO from './helper/SEO';
import 'bootstrap/dist/css/bootstrap.min.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "animate.css/animate.min.css";
import "./style.css";
import "./responsive.css";
import { Helmet } from "react-helmet-async";

import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { BaseUrl } from './helper/BaseUrl';

function App({ initialData, initialSeo, initialGlobalSchema }) {
  const [seoData, setSeoData] = useState(initialSeo || null);
  const [globalSchema, setGlobalSchema] = useState(initialGlobalSchema || null);
  const [initialPath] = useState(() => (
    typeof window !== "undefined" ? window.location.pathname : null
  ));
  const location = useLocation();
  const routeInitialData = typeof window === "undefined" || location.pathname === initialPath
    ? initialData
    : undefined;

  const Detailfetcher = async () => {
    try {
      const response = await fetch(`${BaseUrl}/api/seo-by-url${location.pathname}`, {
        method: 'GET',
      });
      const result = await response.json();
      if (result.seo === false) {
        throw new Error(`API error: ${result.message}`);
      }
      setSeoData(result.seo);
    } catch (error) {
      console.error('Fetch error:', error.message);
    }
  };
  useEffect(() => {
    Detailfetcher();
  }, [location.pathname])

  useEffect(() => {
    const controller = new AbortController();

    const fetchGlobalSchema = async () => {
      try {
        const response = await fetch(`${BaseUrl}/api/global-seo`, {
          method: 'GET',
          signal: controller.signal,
        });
        const result = await response.json();
        setGlobalSchema(result.schema);
      } catch (error) {
        if (error.name !== "AbortError") {
          console.error('Global SEO fetch error:', error.message);
        }
      }
    };

    fetchGlobalSchema();
    return () => controller.abort();
  }, []);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const existingSource = sessionStorage.getItem("source_url");
      if (!existingSource) {
        const landingUrl = window.location.href;
        sessionStorage.setItem("source_url", landingUrl);
      }
    }
  }, []);

  
  useEffect(() => {
    if (typeof window !== "undefined") {
      import("wowjs").then(({ WOW }) => {
        const wow = new WOW({
          live: false,
          mobile: true,
        });
        wow.init();
      });
    }
  }, []);

  useEffect(() => {
    if (typeof window === "undefined" || location.pathname === "/") return undefined;

    let observer;
    let wowInstance;
    let cancelled = false;

    const initialiseCardAnimations = async () => {
      const { WOW } = await import("wowjs");
      if (cancelled) return;

      const main = document.querySelector("main");
      if (!main) return;

      const addCardAnimations = () => {
        let addedAnimation = false;

        main.querySelectorAll(".row").forEach((row) => {
          const columns = Array.from(row.children).filter((child) =>
            Array.from(child.classList).some((className) => /^col(?:-|$)/.test(className))
          );

          if (columns.length < 2) return;

          const isTwoColumnLayout = columns.length === 2;
          columns.forEach((column, index) => {
            if (column.classList.contains("wow")) return;

            column.classList.add(
              "wow",
              "animate__animated",
              isTwoColumnLayout
                ? index === 0
                  ? "animate__slideInLeft"
                  : "animate__slideInRight"
                : "animate__fadeInUp"
            );
            column.setAttribute("data-wow-duration", "1s");
            if (!isTwoColumnLayout) {
              column.setAttribute("data-wow-delay", `${index * 0.1}s`);
            }
            addedAnimation = true;
          });
        });

        if (addedAnimation) wowInstance?.sync?.();
      };

      addCardAnimations();
      observer = new MutationObserver(addCardAnimations);
      observer.observe(main, { childList: true, subtree: true });

      wowInstance = new WOW({
        live: false,
        mobile: true,
      });
      wowInstance.init();
    };

    initialiseCardAnimations();

    return () => {
      cancelled = true;
      observer?.disconnect();
      wowInstance?.stop?.();
    };
  }, [location.pathname]);

  
  return (
    <div className="App">
      <SEO seoData={seoData} initialSeo={initialSeo} globalSchema={globalSchema} />
      <NavRouter initialData={routeInitialData} />
    </div>
  );
}

export default App;
